<template>
  <div class="pageDefaultRadius warning" :class="halfRadius ? 'pageHalfRadius' : ''">
    <i class="iconfont icongantanhao"></i>
    <p>{{message}}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    halfRadius: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="less">
.warning {
  display: flex;
  align-items: center;
  // align-items: center; 
  padding: 10px;
  background: #F9F1AA;
  font-size: 12px;
  .iconfont {
    font-size: 20px;
    float: left;
    margin-right: 5px;
    margin-top: 2px;
    color: #f59a23;
  }
  p {
    color: #6d000e;
    // margin-left: 25px;
    margin-top: 3px;
  }
}
.pageHalfRadius {
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.1);
  .iconfont,
  p {
    color: #fff;
  }
}
</style>
